/**
 * @module Categories
 */

import Component from '../../base/Component';
import Select from '../../base/Select';
import './styles.css';

/**
 * Название компонента.
 */
export default class Categories extends Component {
    static className = 'categories';

    initElements() {
        this.elements = {
            $select: $('.select', this.$block),
        };
    }

    init(options) {
        super.init(options);

        this.setSelect();
    }

    /**
     * Установка селекта, который будет виден на мобильных устройствах
     */
    setSelect() {
        const select = new Select(this.elements.$select);
        select.init({ isSearch: false });
    }
}

/**
 * Актуализация селекта и радио-кнопок
 */
$(document).on('change', '.js-category-field, .select--categories', ({ currentTarget }) => {
    const $target = $(currentTarget);

    // При выборе радио-кнопки, актуализируем селект
    if ($target.hasClass('js-category-field')) {
        const $select = $(`#select-${$target.attr('name')}`);
        const selectInstance = Select.getInstance($select.closest('.select')).instance;

        // Связка между radio-кнопкой и <option> происходит через id (id радио-кнопки === атрибуту "value" у <option>)
        selectInstance.setChoiceByValue($target.attr('id'));
    }

    // И наоборот, при выборе селекта, актуализируем радио-кнопку
    else if ($target.hasClass('select--categories')) {
        const selectInstance = Select.getInstance($target).instance;
        const id = selectInstance.getValue().value;

        $(`#${id}`).trigger('click');
    }
});
